import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm, Controller } from "react-hook-form";

import { format, parseISO } from 'date-fns';

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";

import MainTitle from '../common/MainTitle';
import Modal from '../common/Modal';
import Helper from '../common/Helper';
import Strings from '../common/Strings';
import Toasts from '../common/Toasts';

import './Products.css';

import ProductsStrings from './ProductsStrings';
import ProductsService from './ProductsService';


const ProductEditor = ({ data, onUpdated }) => {

    const [message, setMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const navigate = useNavigate();

    const validationSchema = yup.object().shape({
        name: yup.string().required(),
        description: yup.string(),
    });

    const { register, handleSubmit, setValue, reset, watch, control, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            name: "",
            description: ""
        }
    });

    useEffect(() => {
        if (data) {
            if (data) {
                Object.entries(data).forEach((dataItem) => {
                    setValue(dataItem[0], dataItem[1]);
                });
            }
        }
    }, [data]);

    // id: Optional[int]
    // product_string: str
    // publication_reward: int
    // reply_reward: int
    // description: Optional[str]
    // creation_date: Optional[str]
    // enabled: bool

    const handleUpdate = (formData) => {
        setMessage("");
        setSuccessMessage("");
        const func = data ? ProductsService.update : ProductsService.create;
        func(formData).then((response) => {
            setSuccessMessage("Продукт успешно " + (data ? "обновлен" : "создан"));
            setInterval(() => {
                setSuccessMessage("");
            }, 5000);
            onUpdated();
            if (!data) {
                navigate("/products/");
                reset();
            }
        },
            (error) => {
                setMessage(Helper.errorToString(error));
            });
    };

    return (<div>
        {data && <ul className="no-bullets">
            <li>id: {data.id}</li>
        </ul>}

        <form onSubmit={handleSubmit(handleUpdate)} autoComplete="off">
            <div className="form-group">
                <label>Продукт</label>
                <input role="presentation"
                    name="name"
                    type="text"
                    {...register('name')}
                    className={`form-control ${errors.product_string ? 'is-invalid' : ''}`}
                />
                <div className="form-error">{errors.product_string?.message}</div>
            </div>
            <div className="form-group">
                <label>Описание</label>
                <textarea rows="3" role="presentation"
                    {...register('description')}
                    className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                ></textarea>
                <div className="form-error">{errors.description?.message}</div>
            </div>
            
            <div className="mt-2 d-flex align-items-center justify-content-between">
                <button type="submit" className="btn btn-primary">
                    {data ? "Обновить" : "Создать"}
                </button>
            </div>
        </form>
        {message && (<div className="alert alert-danger mt-4">
            {message}
        </div>)}
        {successMessage && (<div className="alert alert-success mt-4">
            {successMessage}
        </div>)}
    </div>)
}

export default ProductEditor